import CrudService from "@/services/shared/http/CrudService";

export default class ProductService extends CrudService {
  constructor(params = {}) {
    super("products", params);
  }
}
